<template>
  <el-dialog
  title="公域已付款待审核"
  :visible.sync="visibleDialog"
  width="424px"
  top="calc(50vh - 100px)"
  class="pop-dialog pop-public-audit"
  append-to-body>
  <div class="audit-tips">是否确认该销售订单审核通过？</div>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini" :loading="loading">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>



  export default {
    name:'popPublicAudit',
    data () {
      return {
        orderNos:'',
        visibleDialog:false,
        loading: false,
      }
    },

    methods: {
       // 公域审核
      show(orderNos) {
        this.orderNos = orderNos
        this.visibleDialog = true
      },
      // 确认修改
      onConfirm() {
        let postData = {
            orderNos:this.orderNos,
            auditResult:2 // 审核结果: 2-通过, 3-驳回
        }
        console.log('postData:',postData)
        this.loading = true
        this.$api.omsPublicAudit(postData).then((res) => {
          if (res.code == 0) {
            // 一条数据直接弹,多条弹列表
            if(this.orderNos.length ==1){
              let message = res.data.failReasons && res.data.failReasons[0]
              if(res.data.successCount){ 
                this.$message.success(message || '审核成功！')
              }else{ 
                this.$message.error(message || '审核失败！')
              }
            }else if(this.orderNos.length > 1){
                let batchNo =  res.data.batchNo
                let data = {
                  title:'公域已付款待审核处理结果',
                  type:'publicAudit',
                  batchNo
                }
                this.$parent.$refs.popResultTable.show(data)
            }
            this.$emit('fetchData')
          }
        }).finally(() => {
          this.visibleDialog = false
          this.loading = false
        })
      },
    },
  }
</script>
<style lang='scss'>
.pop-public-audit{
  .audit-tips{
    padding: 20px 0 40px;
  }
}
</style>